import React from 'react';
import {useMediaQuery, useTheme} from '@mui/material';
import type {Agent} from 'api/types';
import {useLocalization} from 'localization';
import {selectAgentItems, useSetAgentItems} from 'services/agentItems';
import {useAppSelector} from 'store/hooks';
import {Bar, FlexBox, NextButton, Spacer, Text} from 'components';

type Props = {
  title: string;
  agent?: Agent;
};

export const AgentTitle: React.FC<Props> = ({title, agent}) => {
  const {t} = useLocalization();
  const theme = useTheme();
  const setAgentItems = useSetAgentItems();
  const agentItems = useAppSelector(selectAgentItems);

  // TODO: Refactor breakpoints to represent device types,
  // below should be: useMediaQuery(theme.breakpoints.down('md'));
  const belowMedium = useMediaQuery(theme.breakpoints.down('sm'));

  return belowMedium ? (
    <FlexBox horizontal>
      <Text variant="h1">{title}</Text>
      <Spacer width={2} />
      <NextButton items={agentItems} setter={setAgentItems} />
    </FlexBox>
  ) : (
    <FlexBox paddingBottom={1} sx={{position: 'relative'}}>
      <FlexBox
        horizontal
        alignItems={'center'}
        justifyContent={'space-between'}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
        }}>
        <Text variant="h1">{title}</Text>
        {agent?.agentType ? <Bar spacing={2} height={20} /> : null}
        {agent?.agentType ? (
          <Text variant="h2" kind="disabled">
            {t(`general.entity.${agent.agentType}`)}
          </Text>
        ) : null}

        <Spacer width={2} />
        <NextButton items={agentItems} setter={setAgentItems} />
      </FlexBox>
    </FlexBox>
  );
};
